import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { ProjectCardWidget } from "./ProjectCard.jsx";
import { SkeletonCarousel } from './SkeletonCarousel.jsx';

export function ProjectListWidget({configuration}) {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getProjects();
  }, []);

  const headers = {
      "Accept-Language": window.location.pathname.split("/")[1],
  }

  const getProjects = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, {headers: headers})
      .then(response => response.json())
      .then(data => {
        setProjects(data.results);
        setIsLoading(false);
      }).catch(error => {
        console.log(error);
        setIsLoading(false);
      })
  };

  let title = configuration.translations.title;
  let out;
  if (projects.length > 0) {
    out = (
      <div className="container">
        <h3 className="section__title--float h4">{title}</h3>

            <Slider {...configuration.settings} infinite={projects.length > configuration.settings.slidesToShow}>
              {projects.map(project => 
                <ProjectCardWidget
                  key={project.pk} 
                  project={project}
                  configuration={configuration}
                  />
              )}
            </Slider>
      </div>
    );
  } else {
    out = (
      <div className="container" id="ProcessListWidget">
        <h3 className="section__title--float h4">{title}</h3>
        <div className="min-height-13em">
          <p className="section__description--float my-5">{configuration.translations.emptyMessages}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      { isLoading ? <SkeletonCarousel /> : out }
    </>
  )
}
